import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {LocalDate} from '@js-joda/core';
import {MatTooltip} from '@angular/material/tooltip';
import {MatIcon} from '@angular/material/icon';
import {LocalDateFormatPipe} from '../../pipes/local-date-format.pipe';
import {LocalDateUtil} from '../../utils/date-time/local-date.util';

/** Отображает срок сертификата: полное сообщение или дату с пояснением в tooltip. */
@Component({
  selector: 'app-certificate-expire',
  imports: [MatIcon, LocalDateFormatPipe, MatTooltip],
  templateUrl: './certificate-expire.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificateExpireComponent {
  /** Календарная дата окончания; при отсутствии показывается иконка отсутствия сертификата. */
  public readonly certificateExpire = input<LocalDate | null>(null);
  /** Показывает дату вместо полного сообщения; сообщение доступно в tooltip. */
  public readonly shortView = input(false);

  // Как и раньше, текущая дата определяется при изменении срока, без таймера обновления.
  private readonly validDays = computed(() => {
    const expiry = this.certificateExpire();
    return expiry ? LocalDateUtil.daysBetween(LocalDateUtil.today(), expiry) : 0;
  });

  /** Предупреждение начинается за 30 дней; день окончания ещё не считается просроченным. */
  public readonly expireType = computed<'ok' | 'expiry-soon' | 'expired'>(() => {
    const days = this.validDays();
    return days > 30 ? 'ok' : days >= 0 ? 'expiry-soon' : 'expired';
  });

  /** Пояснение состояния сертификата для полного представления и tooltip. */
  public readonly expireMessage = computed(() => {
    const days = this.validDays();
    const dayLabel = this.getDaysLabel(days);
    if (days > 30) {
      return `Сертификат действителен еще ${days} ${dayLabel}.`;
    }
    if (days >= 0) {
      return `Сертификат скоро истекает осталось ${days} ${dayLabel}.`;
    }
    return `Сертификат просрочен на ${Math.abs(days)} ${dayLabel}.`;
  });

  private getDaysLabel(days: number): string {
    if (days % 10 === 1 && days % 100 !== 11) {
      return 'день';
    }
    if ([2, 3, 4].includes(days % 10) && ![12, 13, 14].includes(days % 100)) {
      return 'дня';
    }
    return 'дней';
  }
}
